module.exports = __webpack_public_path__ + "img/burner-mining-drill-E-shadow.a7da0da4.png";